/**
 * Empty stand-in for zeusIntegration.ts, swapped in via resolve.alias in
 * vite.config.ts when VUE_APP_ZEUS === 'false' (plain / customer-facing
 * builds), so the bundler tree-shakes the entire packages/zeus tree out.
 * Never imported by module path — registered as a knip entry in knip.json.
 * Must stay export-compatible with zeusIntegration.ts.
 */
import type { RouteRecordRaw } from 'vue-router';
import type { ScenarioGroup } from '@/libs/msw/types';

export const zeusRoutes: RouteRecordRaw[] = [];
export const zeusMessages = {} as typeof import('./zeusIntegration').zeusMessages;
export const zeusStoreModules = {} as typeof import('./zeusIntegration').zeusStoreModules;
export const zeusMswScenarios: Record<string, { default: ScenarioGroup | ScenarioGroup[] }> = {};
